import { playgroundApi } from '../../common/api-client';
import { BasePolicyRow, BaseSavingsInsuranceResponse } from '../_shared';
import { Beneficiary, InsuredUniversityFormValues } from './schema';

const PRODUCT = 'UNIVERSITY_SAVINGS_INSURANCE';

export interface UniversityPolicyRow extends BasePolicyRow {
  withdrawal: number;
  policy_value_before_withdrawal?: number;
  policy_value_after_withdrawal?: number;
}

export interface UniversityMonthlyPolicyRow {
  month: number;
  policy_value: number;
  withdrawal: number;
  net_contribution: number;
  [key: string]: number | undefined;
}

export interface InsuredUniversityResponse
  extends BaseSavingsInsuranceResponse<UniversityPolicyRow> {
  projection_by_month: UniversityMonthlyPolicyRow[];
  terminal_excess: number;
}

export interface SimulateParams {
  values: InsuredUniversityFormValues;
  beneficiaries: Beneficiary[];
}

export async function simulateInsuredUniversity({
  values,
  beneficiaries,
}: SimulateParams): Promise<InsuredUniversityResponse> {
  // beneficiaries is JSON-stringified: the backend parses it from a single query param string
  const payload = {
    product: PRODUCT,
    origin_process_id: `playground-${crypto.randomUUID().slice(0, 8)}`,
    ...values,
    beneficiaries: JSON.stringify(beneficiaries),
  };
  const { data } = await playgroundApi.post<InsuredUniversityResponse>(
    'projection/',
    payload,
  );
  return data;
}

export function buildRequestPreview(
  values: InsuredUniversityFormValues,
  beneficiaries: Beneficiary[],
) {
  return {
    product: PRODUCT,
    origin_process_id: 'playground-xxxxxxxx',
    ...values,
    beneficiaries,
  };
}
